import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionService } from './session.service';


@Injectable()
export class SessionAuthGuard  {
  private readonly sessionService = inject(SessionService);

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.sessionService.checkRoute(state.url);
  }
}
